<template>
  <header>
    <div id="mySidenav" class="sidenav text-left">
      <a href="javascript:void(0)" class="closebtn" @click="closeNav()"><span>&times;</span></a>
      <span style="display: none;">{{ msisdn }}</span>
      <a href="javascript:void(0)" class="color-white font-weight-bold" v-if="$session.exists()" data-toggle="modal" data-target="#mdPackageInfo"> <span class="fa fa-user"></span> {{ $session.exists() && $session.has('userInfo') ? $session.get('userInfo').user.substr(0, 7) + 'XXXX' : '' }}</a>
      <a href="/" class="color-white"><span class="fa fa-home"></span> Trang chủ</a>
      <a href="/bai-hat" class="color-white"><span class="fa fa-microphone"></span> Bài hát</a>
      <a href="/bxh" class="color-white"><span class="fa fa-signal"></span> Bảng xếp hạng</a>
      <a href="/nghe-si" class="color-white"><span class="fa fa-headphones"></span> Nghệ sĩ</a>
      <a href="/giai-tri" class="color-white"><span class="fa fa-film"></span> Giải trí</a>
      <a href="/huong-dan" class="color-white"><span class="fa fa-file-word-o"></span> Hướng dẫn</a>
      <a v-if="!$session.exists()" class="color-white" data-toggle="modal" data-target="#mdRegister"><span class="fa fa-check"></span> Đăng ký</a>
      <a v-if="$session.exists() && checkRegisted == false" class="color-white" data-toggle="modal" data-target="#mdRegister2"><span class="fa fa-check"></span> Đăng ký gói</a>
      <a v-if="!$session.exists()" class="color-white" data-toggle="modal" data-target="#mdSignin"><span class="fa fa-user"></span> Đăng nhập</a>
      <a v-if="$session.exists()" class="color-white" @click="logout()"><span class="fa fa-user"></span> Đăng xuất</a>
    </div>

    <div class="text-left d-inline-block float-left">
      <span style="font-size:28px;cursor:pointer; background-color: #00a4e9; border-radius: 3px;color: #fff;padding: 0 0.4rem;margin-left: 0.4rem;"
            @click="openNav()">&#9776;</span>
    </div>

    <div class="logoMobile d-inline-block">
      <a href="/">
        <img src="../../static/img/logoFinal.png"/>
      </a>
    </div>

    <div class="search text-right d-inline-block float-right">
      <span class="fa fa-search" id="searchlabel" @click="showSearch"></span>
    </div>
    <div class="searchform"  v-if="showSearchForm">
      <!--<input type="text" class="s" id="s" name="keyword" placeholder="Nhập từ khóa">-->
      <!--{{ test }}
      <input v-on:input="test=$event.target.value"> Sử dụng điều này thì giá trị test sẽ nhận ngay khi bấm phím trên điện thoại-->
      <autocomplete
        @nameSearch="textSearch=$event"
        :place-holder-text="placeHolderInputText"
        :result-items="autoCompleteResult"
        :result-song-items="autoCompleteSongResult"
        :result-singer-items="autoCompleteSingerResult"
        :on-selected="onSelectedAutoCompleteEvent"
        :on-selected-singer="onSelectedSingerAutoCompleteEvent"
        :on-arrow-down="onArrowDown"
        :on-arrow-up="onArrowUp"
        :on-enter="onEnter"
        :auto-complete-progress="autoCompleteProgress"
        :item-text="autoCompleteText"
        :item-id="autoCompleteFieldId"
        :value-arrow-counter="arrowCounter"
        :value-arrow-counter-singer="arrowCounterSinger"
        :value-input="valueSelected">
      </autocomplete>
      <br>
    </div>
    <signin></signin>

    <div id="mdPackageInfo" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title m-auto">Thông tin gói đăng ký</h4>
          </div>
          <div class="modal-body">
            <p>Xin chào thuê bao <strong class="font-weight-bold">{{ $session.exists() && $session.has('userInfo') ? $session.get('userInfo').user.substr(0, 7) + 'XXXX' : '' }}</strong></p>
            <div v-if="$session.has('packageName')">
              <p v-if="$session.get('packageName').length > 0">Bạn đang sử dụng các gói cước <strong class="font-weight-bold">{{ $session.get('packageName').map(item => item.Package) }}</strong></p>
              <p v-if="$session.get('packageName').length == 0">Bạn chưa đăng ký gói cước</p>
            </div>

            <div v-if="!$session.has('packageName')">
              <p>Bạn chưa đăng ký gói cước dịch vụ!</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Đóng</button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import Signin from './Signin'
  import Autocomplete from './Autocomplete'

  export default {
    name: "HeaderMobile",
    components: {
      "signin": Signin,
      "autocomplete": Autocomplete
    },
    data () {
      return {
        placeHolderInputText: 'Tìm kiếm bài hát, ca sĩ',
        autoCompleteResult: [],
        autoCompleteSongResult: [],
        autoCompleteSingerResult: [],
        autoCompleteProgress: false,
        autoCompleteText: "name",
        autoCompleteFieldId: "inputSearch",
        valueSelected: null,
        arrowCounter: 0,
        arrowCounterSinger: -1,
        textSearch: "",
        check: "",

        showSearchForm: false,

        msisdn: false,
        checkRegisted: false,
      }
    },
    created(){
      //console.log("Session Package: ", this.$session.get('packageName'));
      //console.log("Session Exists: ", this.$session.exists());
      //console.log("Session userInfo: ", this.$session.has('userInfo'));
      //Kiểm tra xem IP truy cập có phải là nhà mạng mobifone không
      if(!this.$session.exists() && this.$route.query.link === undefined && !this.$session.has("redirect")){

        /*axios.get(api.checkTelco)
          .then(response => {
            if(response.data != "#"){
              window.location.href = response.data;
            }
          })
          .catch(e => {
            console.log("Lỗi check telco");
            console.log(e);
          })*/

        //Link Redirect Mobifone
        var redirectUrl = "http://free.mobifone.vn/isdn?sp=1082&link=Jdb39QdeKFJVS4I9orA2GMPVh+AIyzJwpuBIyUWDK/Y=";
        window.location.href = redirectUrl;

      } //End if Session Exists

      //Bắt số điện thoại
      if(this.$route.query.link != undefined){
        this.$session.set("redirect", true); //Đánh dấu là đã redirect sang mobifone

        var link = "xxxx";
        if(this.$route.query.link !== ""){
          link = this.$route.query.link;
        }
        axios.post(api.getPhone, JSON.stringify({ link: link }))
          .then(response => {
            //debugger
            //console.log(response.data);
            var res = response.data;
            //res.phone = '84906074089'; //Set phone for TEST
            if(res.msg = "success" && res.phone != false){
              this.$session.start();
              this.$session.set('userInfo', {'user': res.phone, 'token': ''});
              this.msisdn = true;

              //Check xem số điện thoại đã đăng ký chưa
              axios.get(api.checkRegister + "?msisdn=" + res.phone)
                .then(response => {
                  var resCheck = response.data.result;
                  if(resCheck.length == 0){
                    //Nếu null
                    this.$session.set("isRegisted", false);
                  } else{
                    //Check xem Status kết quả trả về có chứa status = 1 hoặc status = 0 thì đã đăng ký
                    let statusArr = resCheck.filter(item => {
                      return item.Status == 1 || item.Status == 0;
                    });
                    if(statusArr.length > 0){
                      this.checkRegisted = true;
                      this.$session.set("isRegisted", true);
                    } else {
                      this.checkRegisted = false;
                      this.$session.set("isRegisted", false);
                    }

                    //Lấy thông tin tên gói để hiển thị lên Popup Khi click vào số điện thoại
                    this.$session.set('packageName', statusArr);

                    return 'success';
                  }//End If ResCheck.Length
                })
                .then(response => {
                  //Về trang chủ
                  //window.location.href = "/";
                  //this.$router.push("/");
                })
                .catch(e => {
                  console.log(e);
                })
            } //End res.msg == 'success'

          }) //End getPhone
          .catch(e => {
            console.log(e);
          });//End getPhone
      }
    },
    mounted () {
      //Nếu user đăng ký gói rồi
      if(this.$session.has('isRegisted') && this.$session.get('isRegisted')){
        this.checkRegisted = true;
      }
    },
    methods: {
      logout () {
        this.$session.destroy();
        //this.$router.push("/");
        window.location.href = "/";
      },
      openNav(){
        document.getElementById("mySidenav").style.width = "250px";
        //document.getElementById("maincontent").style.marginLeft = "250px";
        document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
      },
      closeNav() {
        document.getElementById("mySidenav").style.width = "0";
        //document.getElementById("maincontent").style.marginLeft= "0";
        document.body.style.backgroundColor = "white";
      },
      showSearch(){
        this.textSearch = "";
        if(this.showSearchForm){
          this.showSearchForm = false;
        } else {
          this.showSearchForm = true;
        }
      },
      onSelectedAutoCompleteEvent (songId, songName) {
        this.showSearchForm = false;
        this.autoCompleteProgress = false;
        this.autoCompleteSongResult = [];
        this.autoCompleteSingerResult = [];
        this.valueSelected = songName;
        this.$router.push(this.settings.prefixSong + songId + '/' + this.convertToAlias(songName) );
      },

      onSelectedSingerAutoCompleteEvent (code, singerName) {
        this.showSearchForm = false;
        this.autoCompleteProgress = false;
        this.autoCompleteSingerResult = [];
        this.autoCompleteSongResult = [];
        this.valueSelected = singerName;
        this.$router.push(this.settings.prefixSinger + code );
      },

      onKeyUpAutoCompleteEvent () {
        //RESET
        this.arrowCounter = 0;
        this.arrowCounterSinger = -1;
        this.autoCompleteSongResult = [];
        this.autoCompleteSingerResult = [];
        this.autoCompleteResult = [];
        this.autoCompleteProgress = false;

        if (this.textSearch.length > 2) {
          this.autoCompleteProgress = true;
          axios.post(api.search, {"keyword": this.textSearch})
            .then(response => {
              this.autoCompleteSongResult = response.data.result.songList;
              this.autoCompleteSingerResult = response.data.result.singerList;
              this.autoCompleteProgress = false;

              if(this.autoCompleteSongResult.length == 0){
                this.arrowCounterSinger = 0;
              }
            })
            .catch(e => {
              console.log(e);
            });
        } else {
          this.autoCompleteProgress = false;
          this.autoCompleteSongResult = [];
        }
      },
      onArrowDown() {
        if (this.arrowCounter < this.autoCompleteSongResult.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }

        if(this.arrowCounter == this.autoCompleteSongResult.length && this.autoCompleteSongResult.length > 0){
          if(this.autoCompleteSingerResult.length > 0){
            if (this.arrowCounterSinger < this.autoCompleteSingerResult.length) {
              this.arrowCounterSinger++;
            }

            if(this.arrowCounterSinger == this.autoCompleteSingerResult.length){
              this.arrowCounterSinger = -1;
              this.arrowCounter = 0;
            }
          } else {
            this.arrowCounter = 0;
          }
        }

        if(this.autoCompleteSongResult.length == 0){
          if (this.arrowCounterSinger < this.autoCompleteSingerResult.length) {
            this.arrowCounterSinger++;
          }

          if(this.arrowCounterSinger == this.autoCompleteSingerResult.length){
            this.arrowCounterSinger = 0;
          }
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0 && this.arrowCounterSinger == -1 && !this.check) {
          this.arrowCounter = this.arrowCounter - 1;
        }

        if (this.arrowCounterSinger > 0) {
          this.arrowCounterSinger--;
          this.arrowCounter = -1;
        } else {
          this.check = true;
          this.arrowCounterSinger = -1;
          if(this.arrowCounter == -1){
            this.arrowCounter = this.autoCompleteSongResult.length;
          }
          if (this.arrowCounter > 0) {
            this.arrowCounter = this.arrowCounter - 1;
          }
        }
      },
      onEnter() {
        if(this.autoCompleteSongResult.length > 0 && this.autoCompleteSingerResult.length == 0){
          this.$router.push(this.settings.prefixSong + this.autoCompleteSongResult[this.arrowCounter].songId + '/' + this.convertToAlias(this.autoCompleteSongResult[this.arrowCounter].songName) );
          this.valueSelected = this.autoCompleteSongResult[this.arrowCounter].songName;
          this.autoCompleteProgress = false;
          this.autoCompleteSongResult = [];
          this.arrowCounter = -1;
        }

        if(this.autoCompleteSingerResult.length > 0 && this.autoCompleteSongResult.length == 0){
          this.valueSelected = this.autoCompleteSingerResult[this.arrowCounterSinger].singerName;
          this.autoCompleteProgress = false;
          this.autoCompleteSingerResult = [];
          this.arrowCounterSinger = -1;
        }

        if(this.autoCompleteSongResult.length > 0 && this.autoCompleteSingerResult.length > 0){
          if(this.arrowCounterSinger > 0 && this.arrowCounterSinger != -1){
            this.valueSelected = this.autoCompleteSingerResult[this.arrowCounterSinger].singerName;
            this.autoCompleteProgress = false;
            this.autoCompleteSingerResult = [];
            this.autoCompleteSongResult = [];
            this.arrowCounterSinger = -1;
          } else {
            this.$router.push(this.settings.prefixSong + this.autoCompleteSongResult[this.arrowCounter].songId + '/' + this.convertToAlias(this.autoCompleteSongResult[this.arrowCounter].songName) );
            this.valueSelected = this.autoCompleteSongResult[this.arrowCounter].songName;
            this.autoCompleteProgress = false;
            this.autoCompleteSingerResult = [];
            this.autoCompleteSongResult = [];
            this.arrowCounter = -1;
          }
        }
        this.showSearchForm = false;
      }
    },
    watch: {
      "textSearch": {
        handler: "onKeyUpAutoCompleteEvent",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  header{
    margin: 0.5rem 0 0 0;
  }
  .sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background-color: #0e719b;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 30px;
  }

  .sidenav a:not(.closebtn) {
    padding: 10px 8px 10px 32px;
    text-decoration: none;
    font-size: 16px;
    color: #818181;
    display: block;
    transition: 0.3s;
    text-transform: capitalize !important;
  }

  .sidenav a:hover {
    color: #f1f1f1;
  }

  .sidenav .closebtn {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    font-size: 28px;
    background-color: #00a4e9;
    border-radius: 15px;
    color: #fff;
    width: 30px;
    height: 30px;
    text-align: center;
  }
  .sidenav .closebtn span{
    position: relative;
    top: -0.35rem;
  }

  @media screen and (max-height: 450px) {
    .sidenav {padding-top: 15px;}
    .sidenav a {font-size: 18px;}
  }

  .logoMobile img{
    width: 100%;
    position: relative;
    right: 1rem;
    top: -0.3rem;
  }


  .search span{
    font-size: 18px;
    background-color: #00a4e9;
    color: #fff;
    padding: 0.56rem;
    border-radius: 3px;
    position: relative;
    right: 0.3rem;
    top: 0.2rem;
  }
  .searchform {
    min-width: 100%;
    min-height: 40px;
    top: 50px;
    right: 0;
    cursor: default;
    background: #00a4e9;
    font-size: 12px;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 90;
  }
  .search.open .searchform {
    display: block;
  }

  #search {
    display: block;
    position: relative;
  }

  #s {
    width: 100%;
    background: #007bff;
    padding: 0px 10px;
    border: 0;
    color: #eee;
    border-radius: 30px;
  }

  .sbtn {
    display: block;
    position: absolute;
    right: 5px;
    top: 0;
    background: none;
    border: none;
    color: #bcbcbc;
    font-size: 0.6em;
    cursor: pointer;
    font-size: 18px;
    margin-right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderMobile.vue